import { createSlice } from 'utils/@reduxjs/toolkit';
import { InsertsState } from './types';
import { reducers } from './reducers';

export const initialState: InsertsState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'inserts',
  initialState,
  reducers,
});

export const { actions: insertsActions } = slice;
export const { reducer: insertsReducer } = slice;
